// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1144":"3db5fcb7","4143":"6c68cbe0","6914":"3db5fcb7","8334":"ac8e41e0","8693":"3e2311e8"}[chunkId] + ".chunk.css";
};